// Wires the eager-init-on-first-pointerdown effect at the top of the app.
// Use once in App (or a layout component) — not per-screen.

import { useEffect } from 'react';
import { eagerInit } from '@/lib/audioContext';

export function useEagerAudioInit(): void {
  useEffect(() => {
    const onDown = () => { eagerInit(); };
    document.addEventListener('pointerdown', onDown, { capture: true, once: true });
    return () => document.removeEventListener('pointerdown', onDown, { capture: true });
  }, []);
}
